import { Stack } from '@healthinal/ui';
import { createFileRoute } from '@tanstack/react-router';
import { PersonHistory } from '../components/PersonHistory.tsx';

export const Route = createFileRoute('/masterdata/persons/$personId/history')({
  component: RouteComponent,
  staticData: { title: 'Verlauf' },
});

function RouteComponent() {
  const { personId } = Route.useParams();

  return (
    <Stack flex={1} gap={2}>
      <PersonHistory personId={personId} />
    </Stack>
  );
}
